/* Calibre — fichas de categoria y barra inferior de movil.
   Agosto 2026, pedido de la clienta.

   POR QUE TODO EL MARCADO SE ARMA ACA, Y NO EN LIQUID:
   lo natural seria declararlo en calibre-searchbar.liquid, pero ese archivo
   pesa 16 KB y hoy no hay forma fiable de reescribirlo por la API (el VPS
   rechaza la llave y la subida por URL desde el CDN de Shopify se descarta en
   silencio). Las categorias YA estan en la pagina, en la fila .cal-catnav, y
   de ahi salen el nombre y el enlace de cada ficha. La barra inferior es fija,
   sin datos de la tienda, asi que tampoco necesita Liquid.

   Ninguna de las dos toca archivos del tema: las fichas se insertan en el
   cajon del menu y la barra se cuelga del <body>. */
(function () {
  var WA = 'https://wa.me/56954586759';

  /* Set de linea propio, la misma reticula de 24 y el mismo trazo que
     snippets/calibre-icono.liquid. Este array se GENERA desde ese snippet: si
     hay que retocar un icono se toca alla y se vuelve a generar, nunca aca a
     mano, o el cajon y la home terminan mostrando dibujos distintos. */
  var ICONOS = [
    ['lifting', ['<path d="M3.6 14.6c4.2-6.2 12.6-6.2 16.8 0"/>', '<path d="M7.1 12.4 5.7 8.6"/>', '<path d="M12 11.2V7.1"/>', '<path d="m16.9 12.4 1.4-3.8"/>', '<path d="M4 18.6h16"/>']],
    ['laminado', ['<path d="M3.6 14.6c4.2-6.2 12.6-6.2 16.8 0"/>', '<path d="M7.1 12.4 5.7 8.6"/>', '<path d="M12 11.2V7.1"/>', '<path d="m16.9 12.4 1.4-3.8"/>', '<path d="M4 18.6h16"/>']],
    ['extensi', ['<path d="M4.4 18.4c4.8-.2 9-2.4 12.2-6.4"/>', '<path d="M4.4 18.4c3.6-1.4 6.6-4 8.6-7.6"/>', '<path d="M4.4 18.4c2.4-2.4 4.2-5.4 5.2-8.8"/>', '<path d="M4.4 18.4C5.6 15.4 6.2 12.2 6.1 9"/>', '<path d="M4.4 18.4h15.2"/>']],
    ['pesta', ['<path d="M4.4 18.4c4.8-.2 9-2.4 12.2-6.4"/>', '<path d="M4.4 18.4c3.6-1.4 6.6-4 8.6-7.6"/>', '<path d="M4.4 18.4c2.4-2.4 4.2-5.4 5.2-8.8"/>', '<path d="M4.4 18.4C5.6 15.4 6.2 12.2 6.1 9"/>', '<path d="M4.4 18.4h15.2"/>']],
    ['ceja', ['<path d="M2.9 13.2C6.2 9 12.8 7.4 18.2 9.6"/>', '<path d="M5.5 12 4.3 9.4"/>', '<path d="M8.7 10.4 7.9 7.6"/>', '<path d="M12 9.6 11.6 6.7"/>', '<path d="m15.3 10 .2-2.9"/>', '<path d="M3.2 17.6c4-2.4 9.4-2.8 14-1"/>']],
    ['marca', ['<path d="m12 2.6 2.2 2.1 3-.3.9 2.9 2.5 1.7-1.3 2.7 1.3 2.7-2.5 1.7-.9 2.9-3-.3-2.2 2.1-2.2-2.1-3 .3-.9-2.9-2.5-1.7 1.3-2.7-1.3-2.7 2.5-1.7.9-2.9 3 .3z"/>', '<path d="m9.2 12 2 2 3.6-3.8"/>']],
    ['kit', ['<path d="M20.4 7.9v8.2a1.4 1.4 0 0 1-.72 1.22l-7 3.85a1.4 1.4 0 0 1-1.36 0l-7-3.85A1.4 1.4 0 0 1 3.6 16.1V7.9a1.4 1.4 0 0 1 .72-1.22l7-3.85a1.4 1.4 0 0 1 1.36 0l7 3.85A1.4 1.4 0 0 1 20.4 7.9Z"/>', '<path d="m3.8 7.2 8.2 4.5 8.2-4.5"/>', '<path d="M12 11.7v9.4"/>', '<path d="m7.9 4.5 8.2 4.5"/>']],
    ['desechable', ['<path d="m2.8 8.4 9.2-4.5 9.2 4.5-9.2 4.5z"/>', '<path d="m2.8 12.6 9.2 4.5 9.2-4.5"/>', '<path d="m2.8 16.4 9.2 4.5 9.2-4.5"/>']],
    ['descartable', ['<path d="m2.8 8.4 9.2-4.5 9.2 4.5-9.2 4.5z"/>', '<path d="m2.8 12.6 9.2 4.5 9.2-4.5"/>', '<path d="m2.8 16.4 9.2 4.5 9.2-4.5"/>']],
    ['cuidado', ['<path d="M9.3 9.1h5.4a2.6 2.6 0 0 1 2.6 2.6v7a2.6 2.6 0 0 1-2.6 2.6H9.3a2.6 2.6 0 0 1-2.6-2.6v-7a2.6 2.6 0 0 1 2.6-2.6Z"/>', '<path d="M10.4 9.1V6.6h3.2v2.5"/>', '<path d="M9.9 5.1h4.2"/>', '<path d="M9.4 13.6h5.2"/>', '<path d="m19.3 2.6.66 1.84 1.84.66-1.84.66-.66 1.84-.66-1.84-1.84-.66 1.84-.66z"/>']],
    ['belleza', ['<path d="M9.3 9.1h5.4a2.6 2.6 0 0 1 2.6 2.6v7a2.6 2.6 0 0 1-2.6 2.6H9.3a2.6 2.6 0 0 1-2.6-2.6v-7a2.6 2.6 0 0 1 2.6-2.6Z"/>', '<path d="M10.4 9.1V6.6h3.2v2.5"/>', '<path d="M9.9 5.1h4.2"/>', '<path d="M9.4 13.6h5.2"/>', '<path d="m19.3 2.6.66 1.84 1.84.66-1.84.66-.66 1.84-.66-1.84-1.84-.66 1.84-.66z"/>']],
    ['oferta', ['<path d="M3.6 10.4V5.2a1.6 1.6 0 0 1 1.6-1.6h5.2a1.6 1.6 0 0 1 1.13.47l8.2 8.2a1.6 1.6 0 0 1 0 2.26l-5.2 5.2a1.6 1.6 0 0 1-2.26 0l-8.2-8.2A1.6 1.6 0 0 1 3.6 10.4Z"/>', '<circle cx="7.8" cy="7.8" r="1.15"/>']],
    ['descuento', ['<path d="M3.6 10.4V5.2a1.6 1.6 0 0 1 1.6-1.6h5.2a1.6 1.6 0 0 1 1.13.47l8.2 8.2a1.6 1.6 0 0 1 0 2.26l-5.2 5.2a1.6 1.6 0 0 1-2.26 0l-8.2-8.2A1.6 1.6 0 0 1 3.6 10.4Z"/>', '<circle cx="7.8" cy="7.8" r="1.15"/>']],
    ['molde', ['<path d="M3.6 15.4c3.6-6.4 13.2-6.4 16.8 0"/>', '<path d="M6.4 15.4c2.6-4.2 8.6-4.2 11.2 0"/>', '<path d="M3.6 15.4h16.8"/>', '<path d="M12 15.4v4.2"/>']],
    ['adhesiv', ['<path d="M12 3.2c3.5 4.2 5.3 7 5.3 9.3a5.3 5.3 0 1 1-10.6 0c0-2.3 1.8-5.1 5.3-9.3Z"/>', '<path d="M9.4 12.9a2.6 2.6 0 0 0 2.6 2.6"/>']],
    ['pegamento', ['<path d="M12 3.2c3.5 4.2 5.3 7 5.3 9.3a5.3 5.3 0 1 1-10.6 0c0-2.3 1.8-5.1 5.3-9.3Z"/>', '<path d="M9.4 12.9a2.6 2.6 0 0 0 2.6 2.6"/>']],
    ['tinte', ['<path d="M9 3.6h6v3.6l1.9 2.7v9.5a1.6 1.6 0 0 1-1.6 1.6H8.7a1.6 1.6 0 0 1-1.6-1.6V9.9L9 7.2z"/>', '<path d="M9 7.2h6"/>', '<path d="M10.2 13.2h3.6"/>']],
    ['henna', ['<path d="M9 3.6h6v3.6l1.9 2.7v9.5a1.6 1.6 0 0 1-1.6 1.6H8.7a1.6 1.6 0 0 1-1.6-1.6V9.9L9 7.2z"/>', '<path d="M9 7.2h6"/>', '<path d="M10.2 13.2h3.6"/>']],
    ['herramient', ['<path d="M9.2 3.4 11.2 13"/>', '<path d="M14.8 3.4 12.8 13"/>', '<path d="M11.2 13v7.2h1.6V13"/>']],
    ['pinza', ['<path d="M9.2 3.4 11.2 13"/>', '<path d="M14.8 3.4 12.8 13"/>', '<path d="M11.2 13v7.2h1.6V13"/>']],
    ['nuevo', ['<path d="m12 3 2.1 5.7 5.7 2.1-5.7 2.1L12 18.6l-2.1-5.7L4.2 10.8l5.7-2.1z"/>', '<path d="m18.8 16.4.7 1.9 1.9.7-1.9.7-.7 1.9-.7-1.9-1.9-.7 1.9-.7z"/>']],
  ];
  var ICONO_POR_DEFECTO = ['<path d="M4 4.6h6.2v6.2H4zM13.8 4.6H20v6.2h-6.2zM4 13.2h6.2v6.2H4zM13.8 13.2H20v6.2h-6.2z"/>'];

  function iconoDe(titulo) {
    var t = (titulo || '').toLowerCase();
    for (var i = 0; i < ICONOS.length; i++) {
      if (t.indexOf(ICONOS[i][0]) !== -1) return ICONOS[i][1];
    }
    return ICONO_POR_DEFECTO;
  }

  function svg(formas, ancho) {
    var cuerpo;
    if (typeof formas === 'string') {
      cuerpo = '<path d="' + formas + '"/>';
    } else {
      cuerpo = formas.join('');
    }
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' +
      (ancho || 1.4) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      cuerpo + '</svg>';
  }

  function arrancar() {
    fichas();
    tabbar();
  }

  /* --- 1. fichas de categoria, arriba del cajon del menu ------------------ */
  function fichas() {
    var panel = document.querySelector('.cal-searchbar__menu .menu-drawer');
    if (!panel || panel.querySelector('.cal-fichas')) return;

    var enlaces = document.querySelectorAll('.cal-catnav__link');
    if (!enlaces.length) return;

    var caja = document.createElement('div');
    caja.className = 'cal-fichas';
    caja.innerHTML = '<p class="cal-fichas__titulo">Comprar</p><ul class="cal-fichas__grid" role="list"></ul>';
    var lista = caja.querySelector('.cal-fichas__grid');
    for (var i = 0; i < enlaces.length; i++) {
      var a = enlaces[i];
      var titulo = (a.textContent || '').trim();
      var item = a.closest('[data-cal-mega-item]');
      var submenu = item && item.querySelector('[data-cal-mega-panel]');
      var grupos = submenu ? submenu.querySelectorAll('.cal-mega__grupo') : [];
      var fila = document.createElement('li');
      var ficha = document.createElement(grupos.length ? 'summary' : 'a');
      ficha.className = 'cal-ficha';
      ficha.innerHTML = svg(iconoDe(titulo)) + '<span class="cal-ficha__txt"></span>';
      ficha.querySelector('.cal-ficha__txt').textContent = titulo;

      if (grupos.length) {
        var desplegable = document.createElement('details');
        desplegable.className = 'cal-fichas__desplegable';
        var contenido = document.createElement('div');
        contenido.className = 'cal-fichas__submenu';
        var verTodo = submenu.querySelector('.cal-mega__pieenlace');
        contenido.appendChild(enlaceMovil(verTodo || a, 'cal-fichas__todos'));

        for (var j = 0; j < grupos.length; j++) {
          var grupo = grupos[j];
          var encabezado = grupo.querySelector('.cal-mega__grupotit');
          var hijos = grupo.querySelectorAll('.cal-mega__enlace');
          var bloque = document.createElement('div');
          bloque.className = 'cal-fichas__grupo';
          var duplicado = encabezado && hijos.length === 1 &&
            encabezado.getAttribute('href') === hijos[0].getAttribute('href') &&
            encabezado.textContent.trim() === hijos[0].textContent.trim();

          if (encabezado && !duplicado) {
            if (encabezado.tagName === 'A') {
              bloque.appendChild(enlaceMovil(encabezado, 'cal-fichas__grupotitulo'));
            } else {
              var rotulo = document.createElement('p');
              rotulo.className = 'cal-fichas__grupotitulo';
              rotulo.textContent = encabezado.textContent.trim();
              bloque.appendChild(rotulo);
            }
          }

          var sublista = document.createElement('ul');
          sublista.className = 'cal-fichas__enlaces';
          sublista.setAttribute('role', 'list');
          for (var k = 0; k < hijos.length; k++) {
            var hijo = document.createElement('li');
            hijo.appendChild(enlaceMovil(hijos[k], 'cal-fichas__enlace'));
            sublista.appendChild(hijo);
          }
          bloque.appendChild(sublista);
          contenido.appendChild(bloque);
        }

        desplegable.appendChild(ficha);
        desplegable.appendChild(contenido);
        fila.appendChild(desplegable);
      } else {
        ficha.setAttribute('href', a.getAttribute('href'));
        fila.appendChild(ficha);
      }
      lista.appendChild(fila);
    }

    var nav = panel.querySelector('.menu-drawer__navigation');
    if (nav) panel.insertBefore(caja, nav);
    else panel.appendChild(caja);
  }

  function enlaceMovil(origen, clase) {
    var enlace = document.createElement('a');
    enlace.className = clase;
    enlace.setAttribute('href', origen.getAttribute('href'));
    enlace.textContent = origen.textContent.trim().replace(/\s+/g, ' ');
    return enlace;
  }

  /* --- 2. barra inferior de movil ----------------------------------------- */
  function tabbar() {
    if (document.querySelector('.cal-tabbar')) return;

    // Los seis accesos de la referencia que mando la clienta (Blush-Bar).
    // El carrito NO va aca a proposito: la cabecera es fija y ya lo lleva
    // siempre a la vista, seria el mismo boton dos veces en pantalla.
    var items = [
      ['inicio', 'Inicio', '/', 'M4 10.5 12 4l8 6.5V19a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19z'],
      ['menu', 'Comprar', null, 'M4 6.5h16M4 12h16M4 17.5h16'],
      ['nuevo', 'Nuevo', '/collections/all?sort_by=created-descending', 'm12 3.5 2.6 5.6 6.1.8-4.5 4.2 1.2 6-5.4-3-5.4 3 1.2-6L3.3 9.9l6.1-.8z'],
      ['ofertas', 'Ofertas', '/collections/ofertas', 'M3.5 10.5V4.5h6l10 10-6 6zM7.5 8.5h.01'],
      ['chat', 'Chat', WA, 'M20 11.7a8 8 0 0 1-11.9 7L4 20l1.4-4A8 8 0 1 1 20 11.7Z'],
      ['cuenta', 'Cuenta', '/account', 'M12 12.4a3.9 3.9 0 1 0 0-7.8 3.9 3.9 0 0 0 0 7.8M4.8 20.4c.6-3.6 3.6-5.8 7.2-5.8s6.6 2.2 7.2 5.8']
    ];

    var nav = document.createElement('nav');
    nav.className = 'cal-tabbar';
    nav.setAttribute('aria-label', 'Accesos rápidos');

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var clave = items[i][0], rotulo = items[i][1], enlace = items[i][2], d = items[i][3];
      var cuerpo = svg(d, 1.5) + '<span class="cal-tabbar__rotulo">' + rotulo + '</span>';
      if (enlace) {
        var fuera = enlace.indexOf('http') === 0 ? ' target="_blank" rel="noopener"' : '';
        html += '<a class="cal-tabbar__item" href="' + enlace + '"' + fuera +
          ' data-tab="' + clave + '">' + cuerpo + '</a>';
      } else {
        html += '<button class="cal-tabbar__item" type="button" data-tab="' + clave + '">' +
          cuerpo + '</button>';
      }
    }
    nav.innerHTML = html;
    document.body.appendChild(nav);

    var acciones = {
      menu: function () {
        var caja = document.querySelector('.cal-searchbar__menu');
        if (!caja) return;
        // Se pulsa el boton del propio componente del tema. Forzar el <details>
        // a mano abre el panel pero deja el scroll bloqueado, porque el
        // atributo scroll-lock se dispara sin que el componente lo gestione.
        var boton = caja.querySelector('summary, button');
        if (boton) boton.click();
      }
    };

    nav.addEventListener('click', function (e) {
      var item = e.target.closest('[data-tab]');
      if (!item || item.tagName === 'A') return;
      var fn = acciones[item.dataset.tab];
      if (fn) fn();
    });

    // Pestana activa segun la pagina, comparando solo la ruta: los enlaces
    // llevan parametros (?sort_by=...) que no sirven para comparar.
    var ruta = window.location.pathname.replace(/\/$/, '') || '/';
    var activos = nav.querySelectorAll('a[data-tab]');
    for (var k = 0; k < activos.length; k++) {
      var h = activos[k].getAttribute('href') || '';
      if (h.indexOf('http') === 0) continue;
      var suya = h.split('?')[0].replace(/\/$/, '') || '/';
      if (suya === ruta) activos[k].setAttribute('aria-current', 'page');
    }

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }
})();
